// This preference is never an authentication or authorization credential.
export const SHARED_ANALYTICS_COOKIE = 'reazly_analytics_consent';
export const ANALYTICS_CONSENT_VERSION = '3';
export const ANALYTICS_CONSENT_SECONDS = 180 * 24 * 60 * 60;
export type AnalyticsConsentChoice = 'accepted' | 'denied' | 'pending';

export function readAnalyticsConsent(
  cookies: string,
  now = Date.now(),
): AnalyticsConsentChoice {
  const matches = cookies
    .split(';')
    .map((part) => part.trim())
    .filter((part) => part.startsWith(`${SHARED_ANALYTICS_COOKIE}=`));
  // Ambiguous host/domain cookies must not accidentally enable tracking.
  if (matches.length !== 1) return 'pending';
  const match = /^3\.(accepted|denied)\.(\d{10})$/.exec(
    matches[0].slice(SHARED_ANALYTICS_COOKIE.length + 1),
  );
  if (!match) return 'pending';
  const expires = Number(match[2]) * 1000;
  if (expires <= now || expires > now + (ANALYTICS_CONSENT_SECONDS + 60) * 1000)
    return 'pending';
  return match[1] as 'accepted' | 'denied';
}

export function analyticsConsentCookie(
  choice: 'accepted' | 'denied',
  now = Date.now(),
): string {
  const expires = Math.floor(now / 1000) + ANALYTICS_CONSENT_SECONDS;
  return `${SHARED_ANALYTICS_COOKIE}=${ANALYTICS_CONSENT_VERSION}.${choice}.${expires}; Max-Age=${ANALYTICS_CONSENT_SECONDS}; Path=/; Domain=reazly.com; SameSite=Lax; Secure`;
}
